import {Type, Dom, Loc, ajax} from 'main.core';
import {MessageBox, MessageBoxButtons} from 'ui.dialogs.messagebox';
import { EventEmitter } from 'main.core.events';
import "./profilecomponent.css";
import "ui.notification";
import {Manager} from 'fusion.certificate.manager';

export class ProfileComponent
{
	static init( data )
	{
		let profileComponent = new ProfileComponent(data);
		profileComponent.initialize();
	}

	#header;
	#body;

	constructor(options)
	{
		this.rootNode = options.rootNode;
		this.userId = options.userId;
		this.canView = false;
		this.canChange = false;
		this.certificates = [];

		EventEmitter.subscribe(
			'BX.Fusion.Certificate:onCertificateSave',
			this.handleCertificateSave.bind(this),
		);
	}

	initialize()
	{
		BX.Runtime.loadExtension('ui.viewer');
		ajax.runAction(
			'fusion:certificate.Profile.getData',
			{
				data: {
					userId: this.userId 
				}
			}
		).then(
			(response) => {

				this.canView = response.data.canView;
				this.canChange = response.data.canChange;
				this.certificates = response.data.certificates;

				this.draw();
			},
			(response) => {
				console.log(response);
			}
		);
	}

	draw()
	{
		Dom.clean(this.rootNode);

		if ( this.canView === false )
		{
			return;
		}

		this.#header = Dom.create('div', {
			attrs: {
				class: 'intranet-user-profile-container-header'
			},
			children: [
				Dom.create('div', {
					attrs: {
						class: 'intranet-user-profile-container-title'
					},
					text: Loc.getMessage('FUSION_CERTIFICATE_JS_PROFILE_TITLE')
				}),
			]
		});

		if ( this.canChange )
		{
			Dom.append(Dom.create('a', {
				attrs: {
					class: 'intranet-user-profile-container-edit'
				},
				events: {
					click: BX.delegate(this.handleAddButtonClick, this)
				},
				text: Loc.getMessage('FUSION_CERTIFICATE_JS_PROFILE_EDIT_BUTTON')
			}), this.#header);			
		}

		this.#body = Dom.create('div', {
			attrs: {
				class: 'intranet-user-profile-container-body'
			}
		});

		if ( this.certificates.length > 0 )
		{
			this.certificates.forEach((cert)=>{

				let buttonContainerNode = Dom.create('div', {
					attrs: {
						class: 'intranet-user-cert-buttons',
					}
				});

				if ( this.canChange )
				{
					Dom.append(Dom.create('button', {
						attrs: {
							class: "ui-btn ui-btn-light-border ui-btn-sm ui-btn-icon-remove",
							"data-id": cert['ID']
						},
						events: {
							click: BX.delegate(this.handleDeleteCert, this)
						}
					}), buttonContainerNode);
				}

				if( cert['ATTRS'] == null ) cert['ATTRS'] = {};

				Dom.append(Dom.create('div', {
					attrs: {
						'data-id': cert['ID'],
						class: 'intranet-user-cert',
						
					},
					children: [
						Dom.create('a', {
							attrs: Object.assign({
								href: cert['PATH'],
								target: '_blank'
							},cert['ATTRS']),
							props: {
								download: true
							},
							text: cert['NAME']
						}),
						buttonContainerNode
					]
				}), this.#body);
			});
		}
		else
		{
			Dom.append(
				Dom.create('div', {
					attrs: {
						class: "intranet-user-no-certificates"
					},
					text: Loc.getMessage('FUSION_CERTIFICATE_JS_PROFILE_NO_CERTS')
				}), this.#body);
		}

		let resultNode = Dom.create('div', {
			attrs: {
				class: 'intranet-user-profile-container'
			},
			children: [
				this.#header,
				this.#body
			]
		});

		Dom.append(resultNode, this.rootNode);

		BX.SidePanel.Instance.postMessage(
			window,
			'BX.Fusion.Certificate.ProfileComponent:certificateListUpdated', {
				userId: this.userId
			}
		);
	}

	handleDeleteCert( event )
	{
		let certId = event.target.dataset.id;

		MessageBox.show({
			title: Loc.getMessage('FUSION_CERTIFICATE_JS_PROFILE_DELETE_DIALOG_TITLE'),
			message: Loc.getMessage('FUSION_CERTIFICATE_JS_PROFILE_DELETE_DIALOG_MESSAGE'),
			buttons: MessageBoxButtons.OK_CANCEL,
			okCaption: Loc.getMessage('FUSION_CERTIFICATE_JS_PROFILE_DELETE_DIALOG_CONFIRM_BTN'),
			onOk: (messageBox, btnEvent) => {
				ajax.runAction(
					'fusion:certificate.Certificate.delete',
					{
						data: {
							certificateId: certId
						}
					}
				).then(
					(response) => {
						messageBox.close();

						let indx = this.certificates.findIndex((element) => {
							return element['ID']==certId;
						});

						if ( indx >= 0 )
						{
							this.certificates.splice(indx, 1);
							this.draw();
						}
					},
					(response) => {
						console.log(response);
					}
				);
			},
		});
	}

	handleAddButtonClick()
	{
		Manager.openCertificate(0, {
			USER_ID: this.userId,
		});
	}

	handleCertificateSave(event) {
		this.initialize();
	}
}